import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';
import '@/App.css';

// Pages
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import QuotesListPage from './pages/QuotesListPage';
import QuoteUploadPage from './pages/QuoteUploadPage';
import FundRequestsPage from './pages/FundRequestsPage';
import FundRequestCreatePage from './pages/FundRequestCreatePage';
import MaterialRequestsPage from './pages/MaterialRequestsPage';
import MaterialRequestCreatePage from './pages/MaterialRequestCreatePage';
import BillingListPage from './pages/BillingListPage';
import BillingCreatePage from './pages/BillingCreatePage';
import MaterialBillingPage from './pages/MaterialBillingPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AuditLogsPage from './pages/AuditLogsPage';
import UsersPage from './pages/UsersPage';
import QuoteWorkflowPage from './pages/QuoteWorkflowPage';
import JobsheetReviewPage from './pages/JobsheetReviewPage';
import AFMValidationPage from './pages/AFMValidationPage';
import StatusUpdatesPage from './pages/StatusUpdatesPage';
import AuditReportsPage from './pages/AuditReportsPage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotes"
            element={
              <ProtectedRoute>
                <QuotesListPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/quotes/upload"
            element={
              <ProtectedRoute allowedRoles={['Key Account Manager', 'Super Admin', 'Project Head']}>
                <QuoteUploadPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/fund-requests"
            element={
              <ProtectedRoute>
                <FundRequestsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/fund-requests/create"
            element={
              <ProtectedRoute allowedRoles={['Site Supervisor', 'Super Admin', 'Project Head']}>
                <FundRequestCreatePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/material-requests"
            element={
              <ProtectedRoute>
                <MaterialRequestsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/material-requests/create"
            element={
              <ProtectedRoute allowedRoles={['Site Supervisor', 'Super Admin', 'Project Head']}>
                <MaterialRequestCreatePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/billing"
            element={
              <ProtectedRoute allowedRoles={['Billing Manager', 'Billing Executive', 'Account Manager', 'Project Head', 'Key Account Manager', 'Super Admin']}>
                <BillingListPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/billing/create"
            element={
              <ProtectedRoute allowedRoles={['Billing Manager', 'Billing Executive', 'Super Admin']}>
                <BillingCreatePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/billing/material"
            element={
              <ProtectedRoute allowedRoles={['Account Manager', 'Delivery Manager', 'Super Admin']}>
                <MaterialBillingPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <ProtectedRoute allowedRoles={['Project Head', 'Key Account Manager', 'Super Admin']}>
                <AnalyticsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/audit-logs"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Project Head', 'Key Account Manager']}>
                <AuditLogsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Project Head', 'Key Account Manager']}>
                <UsersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/quote-workflow"
            element={
              <ProtectedRoute allowedRoles={['Site Supervisor', 'Super Admin']}>
                <QuoteWorkflowPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/jobsheet-review"
            element={
              <ProtectedRoute allowedRoles={['Billing Manager', 'Super Admin']}>
                <JobsheetReviewPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/afm-validation"
            element={
              <ProtectedRoute allowedRoles={['Billing Manager', 'Project Head', 'Key Account Manager', 'Super Admin']}>
                <AFMValidationPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/status-updates"
            element={
              <ProtectedRoute allowedRoles={['Super Admin', 'Project Head', 'Key Account Manager', 'Site Supervisor', 'Billing Manager', 'Billing Executive', 'Account Manager', 'Delivery Manager']}>
                <StatusUpdatesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/audit-reports"
            element={
              <ProtectedRoute allowedRoles={['Super Admin']}>
                <AuditReportsPage />
              </ProtectedRoute>
            }
          />

          {/* Default Route */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
